<!--
 * @Description:
 * @Autor: xiaona.wang
 * @Date: 2021-07-22 17:11:59
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-11-08 13:41:43
-->
<template>
  <section class="app-main">
    <!-- <transition name="fade-transform" mode="out-in"> -->
    <keep-alive :include="cachedViews">
      <div v-if="isMircApp" id="mircApp" class="h100 overflow-x-y"></div>
      <router-view v-else-if="!$route.path.includes('/dynamic-page')" :key="key" />
    </keep-alive>
    <keep-alive >
      <router-view v-if="$route.path.includes('/dynamic-page')" :key="key"/>
    </keep-alive>
    <!-- <router-view v-if="!$route.meta.keepAlive" /> -->
    <!-- </transition> -->
  </section>
</template>

<script>
import { checkIsMircApp, mircAppBodyClassList, getMircAppBodyClass } from "@/utils/mircApp";
import { start } from "qiankun";
import { mapState } from "vuex";
export default {
  name: "AppMain",
  computed: {
    ...mapState({
      needTagsView: state => {
        const cache = state.settings.tagsView;
        return cache;
      }
    }),
    key() {
      return this.$route.fullPath;
    },
    isMircApp() {
      const { path } = this.$route;
      const isMirc = checkIsMircApp(path);
      const body = document.querySelector("body");
      const htmlEl = document.querySelector("html");
      const classList = mircAppBodyClassList();
      classList.forEach(element => {
        body.classList.remove(element);
      });
      body.classList.remove("scim-common-theme");
      body.classList.remove("scim-common-theme-green");
      if (isMirc) {
        const className = getMircAppBodyClass(path);
        if (path.indexOf("/scim-edm-screen") !== -1) {
          const htmlElClass = htmlEl.className;
          htmlEl.className = htmlElClass.replace(/fontSizeInit/g, "");
        } else {
          htmlEl.className = `${htmlEl.className} fontSizeInit `;
        }
        if (className) {
          body.classList.add(className);
        }
        console.info("==== noCache ====", this.needTagsView, this.$store.state.settings.tagsView);
        this.$actions.setGlobalState({
          event: 5,
          noCache: !this.needTagsView
        });
      } else {
        body.classList.add("scim-common-theme-green");
        body.classList.add("scim-common-theme");
        htmlEl.className = `${htmlEl.className} fontSizeInit `;
      }

      return isMirc;
    },
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    }
  },
  mounted() {
    const option = { prefetch: "all" };
    start(option);
  },
  data() {
    return {
      transitionName: ""
    };
  },
  methods: {}
};
</script>

<style scoped>
.app-main {
  /*50 = navbar  */
  /*min-height: calc(100vh - 50px);*/
  flex: 1;
  width: 100%;
  position: relative;
  overflow: hidden;
  overflow-x: auto;
}
.fixed-header + .app-main {
  padding-top: 96px;
}
</style>

<style lang="scss">
#mircApp {
  height: 100%;
  & > div {
    height: 100%;
  }
}
// fix css style bug in open el-dialog
.el-popup-parent--hidden {
  .fixed-header {
    //padding-right: 15px;
  }
}
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 300ms;
  position: absolute;
}

.slide-right-enter {
  opacity: 0;
  transform: translate(-100%);
}

.slide-right-leave-active {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-enter {
  opacity: 0;
  transform: translateX(100%);
}

.slide-left-leave-active {
  opacity: 0;
  transform: translateX(-100%);
}
</style>
